import { Connector } from '../../common/redux/api/web-api'

export function isUserHasAccessToConnector(
    connector?: Connector | null,
    ownerId?: string | null,
    userId?: string
): boolean {
    if (connector === null || connector === undefined) return false
    return (
        userId === undefined ||
        userId === null || //Admin
        ownerId === userId ||
        connector.connectorUserId === userId
    )
}

export function isUserHasAccessToAnyConnector(connectors: Connector[], ownerId: string, userId?: string): boolean {
    return connectors.find((connector) => isUserHasAccessToConnector(connector, ownerId, userId)) !== undefined
}
